// GraphQL variables for one page of the recordings list. The two contexts call different
// queries with different argument names — the owner's list uses recordingsTextSearch
// (`string`, `pageSize`), a public profile uses searchPublicRecordings (`query`, `perPage`).
// Sending the owner's names to the public query silently dropped them: the search box did
// nothing, and the server fell back to 20 per page, so a page never matched the 10 the
// list checks for and "See more" never appeared.

import { normalizeRecordingSort } from '../../utils/helpers/recordingSortOptions'
import { recordingSourcesVariable } from '../../utils/helpers/recordingSourceFilter'
import type { RecordingListFilterVariables } from '../../utils/helpers/recordingListFilters'

export interface RecordedTrailsListState {
  isPublicContext: boolean
  firebaseUserId?: string | null
  searchString?: string | null
  startDate?: string | null
  endDate?: string | null
  sort?: string | null
  source?: string | null
  /** Distance / elevation / type / tags, from recordingListFilterVariables. Same names on both queries. */
  filters?: RecordingListFilterVariables | null
  page: number
  pageSize: number
}

export function recordedTrailsQueryVariables(state: RecordedTrailsListState): Record<string, unknown> {
  const shared = {
    startDate: state.startDate || null,
    endDate: state.endDate || null,
    sort: normalizeRecordingSort(state.sort),
    sources: recordingSourcesVariable(state.source),
    ...(state.filters || {}),
    page: state.page,
  }

  if (state.isPublicContext) {
    return {
      ...shared,
      firebaseUserId: state.firebaseUserId,
      query: state.searchString?.trim() || null,
      perPage: state.pageSize,
    }
  }

  return {
    ...shared,
    string: state.searchString || '',
    pageSize: state.pageSize,
  }
}
